
    import { Component, Provide, Vue } from 'vue-property-decorator'
    import { ComponentBase } from '@/models/ComponentBase'
    import ProductsForm from '@/components/ProductsForm';
    import { FormStateType } from '@/models/FormStateType';

    @Component({
        components: {
            ProductsForm
        }
    })
    export default class ProductsCreate extends ComponentBase {

        private breadcrumbItems = [
            {
                text: 'Back to products',
                disabled: false,
                href: '/products',
            },
            {
                text: 'Create',
                disabled: true
            }
        ];

        private formState: FormStateType = FormStateType.Create;

        constructor() {
            super();
        }

    }
